export enum BarColorEnum {
    Delivered = '#9e90ed',
    Open = '#4f96eb',
    Click = '#00c6db',
}
